import { render, staticRenderFns } from "./GoodsFilter.vue?vue&type=template&id=5469e140&scoped=true&"
import script from "./GoodsFilter.vue?vue&type=script&lang=js&"
export * from "./GoodsFilter.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFilter.vue?vue&type=style&index=0&id=5469e140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469e140",
  null
  
)

export default component.exports